import { render, staticRenderFns } from "./DialogApproval.vue?vue&type=template&id=5353f87e&scoped=true&"
import script from "./DialogApproval.vue?vue&type=script&lang=js&"
export * from "./DialogApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5353f87e",
  null
  
)

export default component.exports